<template>
  <window-content v-if="!loading">
    <div class="m-t">
      <e-row class="erp-row-col-md">
        <e-col style="max-width: 240px">
          <erp-s-field
              view="lr"
              label="ID:"
              label-width="110px"
          >
            <erp-input simple-border v-model="juizo.id" disable />
          </erp-s-field>
        </e-col>
      </e-row>
      <e-row>

        <e-col style="max-width: 300px">
          <erp-s-field
              view="lr"
              label="Nome:"
              label-width="110px"
          >
            <erp-input simple-border v-model="juizo.nome" required />
          </erp-s-field>
        </e-col>
      </e-row>
    </div>

    <window-footer class="flex content-between">
      <div class="inline-block window-actions text-right self-end col-grow">
        <u-btn label="Cancelar" icon="chevron-left" icon-type="fa" icon-style="light" flat no-caps
               @click="$uloc.window.close($root.wid)" />
        <u-btn label="Salvar (F2)" icon="save" icon-type="fa" icon-style="light" flat no-caps
               @click="save"
               v-shortkey="['f2']" @shortkey.native="save" />
      </div>
    </window-footer>
  </window-content>
  <window-loading :errors="errors" :status="status" v-else></window-loading>
</template>

<script>
import {
  WindowContent,
  WindowFooter,
  ErpSField,
  ErpInput
} from 'uloc-vue-plugin-erp'
import WindowLoading from "../../../../layout/window/Loading";
import ERow from "../../../../layout/components/Row";
import ECol from "../../../../layout/components/Col";
import {newJuizo, update, find} from "../../../../../domain/processos/services/juizo";

export default {
  name: 'JuizoWindow',
  props: ['id'],
  components: {
    WindowContent,
    WindowFooter,
    ErpSField,
    ErpInput,
    ERow,
    ECol,
    WindowLoading
  },
  data () {
    return {
      juizo: {
        id: null,
        nome: null
      },
      loading: !!this.id,
      status: null,
      errors: null
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load () {
      this.id && find(this.id)
          .then(response => {
            this.juizo = response.data
            this.$nextTick(() => {
              this.loading = false
            })
          })
          .catch((error) => {
            this.$uloc.dialog({
              title: 'Falha ao carregar!',
              color: 'negative',
              message: `Não conseguimos carregar os dados do juízo, entre em contato com o administrador.`
            })
            this.loading = false
            this.errors = error.data
            console.error(error, error.data)
          })
    },
    save () {
      this.loading = true
      this.status = 'Processando juízo'
      const data = {...this.juizo}
      const method = data.id ? update(data.id, data) : newJuizo(data)
      method
          .then(({data}) => {
            this.juizo.id = data.id
            this.success = true
            this.$nextTick(() => {
              // this.$refs.timer.start()
              window.setTimeout(() => {
                this.loading = false
                this.success = false
                this.load()
              }, 3000)
              this.$uloc.window.emit(this.$root.wid, 'update', this.props)
            })
          })
          .catch(error => {
            console.log(error)
            this.success = false
            this.errorMessage = error.data.message
            // this.errors = this.systemError(error)
            this.$nextTick(() => {
              this.loading = false
              this.alertApiError(error)
              // this.error = true
            })
          })
    },
    open () {
      console.log('TODO open')
    }
  }
}
</script>
